import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import IndexSection from './components/IndexSection';
import MediaSection from './components/MediaSection';
import UpdatesSection from './components/UpdatesSection';
import CommentsSection from './components/CommentsSection';
import FeaturesSection from './components/FeaturesSection';
import AppSection from './components/AppSection';
import AboutSection from './components/AboutSection';
import FaqSection from './components/FaqSection';
import CarouselSection from './components/CarouselSection';
import RankingSection from './components/RankingSection';
import CardsSection from './components/CardsSection';
import ContactSection from './components/ContactSection';
import TopicsSection from './components/TopicsSection';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <IndexSection />
        <MediaSection />
        <UpdatesSection />
        <CommentsSection />
        <FeaturesSection />
        <AppSection />
        <AboutSection />
        <FaqSection />
        <CarouselSection />
        <RankingSection />
        <CardsSection />
        <ContactSection />
        <TopicsSection />
      </main>
      <Footer />
    </>
  );
}